import React from "react"

import {FormattedMessage} from "@irati/utils/lang"
import {H1} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"

interface Props {
  title: string
  buttonLabel: string
  isRecognitionEnabled: boolean
  showForm: () => void
}

const TitleAndCreate = ({title, buttonLabel, isRecognitionEnabled, showForm}: Props) => (
  <Flex justifyContent="space-between" alignItems="center">
    <H1>
      <FormattedMessage id={title} />
    </H1>
    {isRecognitionEnabled && (
      <Button id="settingsCompanyCelebrationAdd_button" primary onClick={showForm}>
        <FormattedMessage id={buttonLabel} />
      </Button>
    )}
  </Flex>
)

export default TitleAndCreate
